import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider
} from "@tanstack/react-query";
import type { ReactNode } from "react";

function buildQueryClient() {
  const queryClient = new QueryClient();
  queryClient.setDefaultOptions({
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount >= 2) return false;
        const status = (error as { status?: number })?.status;
        return !status || status >= 500;
      },
      retryDelay: attempt => Math.min(1000 * 2 ** attempt, 30_000),
      staleTime: 60_000
    },
    mutations: {
      onMutate: context => context
    }
  });
  return queryClient;
}

const queryClient = buildQueryClient();

type QueryClientProviderProps = {
  children: ReactNode;
};

export function QueryClientProvider({ children }: QueryClientProviderProps) {
  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}
